import type { FireflyRuntime, ModuleRegisterFunction } from "@squide/firefly";

export const registerAssistant: ModuleRegisterFunction<FireflyRuntime> = async runtime => {
    if (runtime.isMswEnabled) {
        const [{ customSkillsRequestHandler }, { skillAttachmentsRequestHandler, skillAttachmentUploadRequestHandler }] = await Promise.all([import("./mocks/custom-skills/customSkillsRequestHandler.ts"), import("./mocks/skill-attachments/skillAttachmentsRequestHandler.ts")]);

        runtime.registerRequestHandlers([customSkillsRequestHandler, skillAttachmentsRequestHandler, skillAttachmentUploadRequestHandler]);
    }
};
